<template>
  <base-dialog
    width="560px"
    show-close
    :visible.sync="visible"
    class="save-master-rule-dialog"
    v-ps="'.el-dialog__body'"
    v-loading="loading"
  >
    <template v-slot:header>{{ title }}</template>
    <el-form ref="form" :model="dingGroup" label-width="110px" :rules="rules" label-position="left">
      <div class="form-group">
        <div class="body">
          <el-form-item label="机器人名称" prop="name">
            <el-input v-model="dingGroup.name"></el-input>
          </el-form-item>
          <el-form-item label="机器人Token" prop="dingRobotToken">
            <el-input v-model="dingGroup.dingRobotToken"></el-input>
          </el-form-item>
          <el-form-item label="机器人密钥" prop="dingRobotSecret">
            <el-input v-model="dingGroup.dingRobotSecret"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import { createDingGroup, updateDingGroup } from "@/api/dingGroup"
import { deepClone } from "@/utils/common"

export default {
  name: "save-master-rule-dialog",
  components: { BaseDialog, BaseButton },
  inject: ["app"],
  data() {
    return {
      visible: false,
      loading: false,
      syncRule: {},
      rules: {
        name: [{ required: true, message: "请输入机器人名称", trigger: "blur" }],
        dingRobotToken: [{ required: true, message: "请输入机器人Token", trigger: "blur" }],
        dingRobotSecret: [{ required: true, message: "请输入机器人秘钥", trigger: "blur" }]
      },
      dingGroup: {
        name: "",
        dingRobotToken: "",
        dingRobotSecret: ""
      }
    }
  },
  props: {
    create: Boolean
  },
  computed: {
    title() {
      return this.create ? "新建群机器人" : "更新群机器人"
    }
  },
  methods: {
    open(row) {
      this.visible = true
      if (row) {
        this.dingGroup = deepClone(row)
      } else {
        this.dingGroup = {}
      }
    },
    sheetChange() {
      this.syncRule = Object.assign({}, this.syncRule, {
        targetCId: "",
        rows: [],
        filters: []
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.create) {
          this.dingGroup.appId = this.app.id
          createDingGroup(this.dingGroup, this.app.id).then(res => {
            this.$message.success("操作成功")
            this.visible = false
            this.$emit("change")
          })
        } else {
          updateDingGroup(this.dingGroup).then(res => {
            this.$message.success("操作成功")
            this.visible = false
            this.$emit("change")
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.save-master-rule-dialog {
  .el-select {
    width: 100%;
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
  .form-group {
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
      margin-bottom: 14px;
    }
  }
}
</style>
